import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-2xl p-8 text-center">
      <h1 className="text-2xl font-bold">404 — Page not found</h1>
      <p className="mt-3 text-gray-600">
        We couldn't find the page you were looking for. It may have moved, or the
        link may be incorrect.
      </p>
      <div className="mt-6 flex justify-center gap-3">
        <Link
          to="/"
          className="inline-block rounded bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-700"
        >
          Back to home
        </Link>
        <Link
          to="/login"
          className="inline-block rounded border border-gray-300 px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100"
        >
          Sign in
        </Link>
      </div>
    </div>
  );
}
